import request from '../utils/request';

const mole = 'section';
export default {
  // 获取所有版块(专题)
  findAll: () => {
    return request({
      url: `/api/${mole}/list_all`,
      method: 'get'
    });
  },
  // 添加版块
  add: params => {
    return request({
      url: `/api/${mole}/add`,
      method: 'post',
      data: params
    });
  },
  // 添加版块名称
  updateTitle: (id, params) => {
    return request({
      url: `/api/${mole}/update_title/${id}`,
      method: 'post',
      data: params
    });
  },
  // 批量更新版块排序
  updateSort: params => {
    return request({
      url: `/api/${mole}/update_sort`,
      method: 'post',
      data: params
    });
  },
  deleteById: (id, params) => {
    return request({
      url: `/api/${mole}/delete/${id}`,
      method: 'post',
      data: params
    });
  }
};
